import { render, staticRenderFns } from "./PremiumCategoriesCards.vue?vue&type=template&id=a32b155e&scoped=true&"
import script from "./PremiumCategoriesCards.vue?vue&type=script&lang=js&"
export * from "./PremiumCategoriesCards.vue?vue&type=script&lang=js&"
import style0 from "./PremiumCategoriesCards.vue?vue&type=style&index=0&id=a32b155e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32b155e",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCard, BCardGroup} from 'bootstrap-vue'
    installComponents(component, {BCard, BCardGroup})
    

export default component.exports